<template>
  <div class="full-screen" style="z-index: 9;">
    <top id="top-nav" :title="chapterInfo.bookName" :title2="chapterInfo.title"
         :key="`${chapterInfo.bookId}-${chapterInfo.chapterId}`"></top>
    <div id="scroll-div-book-read" class="main" style="height: 100vh; overflow: auto;">
      <div class="mt25 mb25">
        <book-content :bookid="chapterInfo.bookId" :booktitle="chapterInfo.bookName" :chapternum="chapterInfo.number" :imgs="chapterInfo.bookPics" :picSplitCount="chapterInfo.picSplitCount"></book-content>
      </div>
    </div>

    <div id="bottom-nav" class="bottomBox">
      <div class="btn b1" @click="toCatalog"><img src="../../../assets/images/icon-8.png"/>目录</div>
      <div :class="['btn', 'b2', {'disabled': chapterInfo.number === 1}]" @click="toLastChapter">上一章</div>
      <div :class="['btn', 'b3', {'disabled': chapterInfo.number === chapterInfo.totalNumber}]" @click="toNextChapter">
        下一章
      </div>
      <div class="btn b4" @click="addShelf"><img src="../../../assets/images/icon-7.png"/>{{addedToShelf ? '移除' : '收藏'}}</div>
    </div>


    <!--    <div v-if="showBuy" id="buy-confirm" class="fixed-pay" style="display: block;" @click.self="hideBuyConfirmHandler">-->
    <div v-if="showBuy" id="buy-confirm" class="fixed-pay" style="display: block;">
      <div class="fixed-c">
        <h3>本章价格：<strong>{{buyPrice}}</strong>金币</h3>
        <p class="v" v-if="chapterInfo.bookVipFree">开通VIP，海量漫画免费看</p>
        <p class="v" v-else>本书不属于VIP免费阅读作品，请购买阅读</p>
        <div class="auto-pay">
          <input v-model="autoBuy" id="autoBuyCheckBox" type="checkbox" class="checkbox" @click="changeAutoBuy">
          <span><label for="autoBuyCheckBox">自动购买下一话</label></span>
          <span class="r">余额：{{userInfo.avaliableAmount}}金币</span>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="buyChapter">购买本章节</button>
        </div>
      </div>
    </div>

    <div v-if="showRecharge" id="recharge-confirm" class="fixed-pay" style="display: block;">
      <div class="fixed-c">
        <h3>本章价格：<strong>{{buyPrice}}</strong>金币</h3>
        <p class="v" v-if="chapterInfo.bookVipFree">开通VIP，海量漫画免费看</p>
        <p class="v" v-else>本书不属于VIP免费阅读作品，请购买阅读</p>
        <div class="auto-pay">
          <input v-model="autoBuy" id="autoBuyCheckBox" type="checkbox" class="checkbox" @click="changeAutoBuy">
          <span><label for="autoBuyCheckBox">自动购买下一话</label></span>
          <span class="r">余额：{{userInfo.avaliableAmount}}金币</span>
        </div>
        <div class="btnbox">
          <button class="btn" type="button" @click="goPurchase">金币不足，前往充值</button>
        </div>
      </div>
    </div>

    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>
  </div>
</template>

<script>
  import Alert from '@/components/share/alert'
  import BookContent from '@/components/layer2/book/read-content'
  import BookTop from '@/components/layer2/book/book-top'

  import shelfService from "../../../services/shelfService";
  import bookService from "../../../services/bookService";
  import scrollService from "../../../services/scrollService";
  import payService from "../../../services/payService";
  import userService from "../../../services/userService";
  import kkUtil from "../../../assets/js/kk-util";

  export default {
    name: "read",
    data() {
      return {
        showBuy: false,
        showRecharge: false,
        buyPrice: 0,
        autoBuy: false,
        chapterId: 0,
        showAlert: false,
        alertMsg: '',
        isShowMenu: true,
        addedToShelf: false,
        chapterInfo: {
          bookId: 0,
          bookName: '',
          bookPics: [],
          picSplitCount: 1,
          bookPrice: 0,
          bookVipFree: true,
          chapterId: 0,
          content: '',
          lastNumber: 0,
          nextNumber: 0,
          number: 0,
          price: 0,
          title: '',
          totalNumber: 0
        },
        userInfo: {}
      }
    },
    methods: {
      getUserInfo() {
        this.userInfo = userService.getLocalUserInfo();
      },
      getChapter(id, number) {
        if (kkUtil.isEmpty(id) || kkUtil.isEmpty(number)) {
          this.alertMsg = "当前书本信息未加载，请返回主页重新操作";
          this.showAlert = true;
        } else {
          bookService.getChapterImg(id, number)
            .then(res => {
              if (res.result) {
                this.chapterInfo = res.data;
                this.isAddedToShelf();
                this.bookPics = res.data ? res.data.bookPics : [];
                this.$emit('update-top-title', res.data.bookName, res.data.title);
              } else if (res.code === 999) {
                this.chapterInfo = res.data;
                this.checkAutoBuy();
                this.$emit('update-top-title', res.data.bookName, res.data.title);
              } else if (res.code === 400) {
                this.alertMsg = '没有更多章节啦 ^_^ ';
                this.showAlert = true;
              } else if (res.code === 101) {
                userService.getUserInfo();
                this.alertMsg = '网络拥堵，请重新加载本页面哦 ^_^ ';
                this.showAlert = true;
              }
            })
        }
      },
      toCatalog() {
        this.$router.isBack = false;
        this.$router.push(`/book/${this.$route.params.id}/catalog`);
      },
      toLastChapter() {
        if (this.chapterInfo.number > 1) {
          this.$router.isBack = false;
          this.$router.replace(`/book/read/${this.chapterInfo.bookId}/${this.chapterInfo.number - 1}`)
        } else {
          this.alertMsg = '已经是第一章啦';
          this.showAlert = true;
        }
      },
      toNextChapter() {
        if (this.chapterInfo.number < this.chapterInfo.totalNumber) {
          this.$router.isBack = false;
          this.$router.replace(`/book/read/${this.chapterInfo.bookId}/${this.chapterInfo.number + 1}`)
        } else {
          this.alertMsg = '已经是最后一章啦';
          this.showAlert = true;
        }
      },
      toShelf() {
        this.$router.isBack = false;
        this.$router.push('/shelf');
      },
      addShelf() {
        this.addedToShelf = shelfService.addShelf({
          bookId: this.chapterInfo.bookId,
          title: this.chapterInfo.bookName,
          cover: this.chapterInfo.bookCover,
          horiCover: this.chapterInfo.bookCover
        });
      },
      isAddedToShelf() {
        let shelfBook = shelfService.getShelf().find(item => {
          return item.title === this.chapterInfo.bookName
        });
        this.addedToShelf = !!shelfBook;
      },
      updateHistory() {
        let history = shelfService.getHistoryById(this.$route.params.id);
        if (history) {
          history.number = this.$route.params.number;
          shelfService.updateHistory(this.$route.params.id, this.$route.params.number);
        } else {
          bookService.getDetail(this.$route.params.id)
            .then(res => {
              let bookInfo = res.data.book;
              shelfService.addHistory(bookInfo, this.$route.params.number);
            })
        }
      },
      showBuyConfirm(price, chapterId) {
        this.chapterId = chapterId;
        this.buyPrice = price;
        this.showBuy = true;
      },
      changeAutoBuy() {
        this.autoBuy = document.querySelector('#autoBuyCheckBox').checked;
        if (this.autoBuy) {
          payService.addAutoBuyList(this.chapterInfo.bookId);
        } else {
          payService.removeAutoBuy(this.chapterInfo.bookId);
        }
      },
      buyChapter() {
        bookService.buyChapter(this.chapterInfo.chapterId)
          .then(res => {
            if (res.result) {
              if (!this.autoBuy) {
                this.alertMsg = '购买成功';
                this.showAlert = true;
              }
              this.getChapter(this.$route.params.id, this.$route.params.number);
              this.showBuy = false;
            } else if (res.code === 999) {
              this.showBuy = false;
              this.showRecharge = true;
            }
          })
      },
      goPurchase() {
        this.$router.isBack = false;
        this.$router.push({path: `/purchase`, query: {bookId: this.chapterInfo.bookId}});
      },
      checkAutoBuy() {
        if (payService.isAutoBuy(this.chapterInfo.bookId)) {
          this.buyChapter();
        } else {
          this.showBuyConfirm(this.chapterInfo.price, this.chapterInfo.chapterId);
        }
      },
      hideBuyConfirmHandler() {
        let obj = document.getElementById('buy-confirm');
        obj.style.opacity = 1;
        this.hideBuyConfirm(obj);
      },
      hideBuyConfirm(obj) {
        obj.style.opacity -= 0.05;
        if (obj.style.opacity > 0) {
          setTimeout(() => {
            this.hideBuyConfirm(obj);
          }, 15);
        } else {
          this.showBuy = false;
        }
      },
      showMenu() {
        let btm = document.getElementById('bottom-nav');
        btm.style.bottom = '0px';
        let top = document.getElementById('top-nav');
        top.style.top = '0rem';
      },
      hideMenu() {
        let btm = document.getElementById('bottom-nav');
        btm.style.bottom = '-60px';
        let top = document.getElementById('top-nav');
        top.style.top = '-2.5rem';
      },
      scrollFunction() {
        if (scrollService.isReachTop('scroll-div-book-read') || scrollService.isReachBottom('scroll-div-book-read')) {
          this.showMenu();
        } else {
          this.hideMenu();
        }
      }
    },
    components: {
      alert: Alert,
      'book-content': BookContent,
      top: BookTop
    },
    mounted() {
      this.autoBuy = payService.isAutoBuy(this.$route.params.id);
      this.getUserInfo();
      this.updateHistory();
      this.getChapter(this.$route.params.id, this.$route.params.number);
      let obj = document.getElementById('scroll-div-book-read');
      obj.addEventListener('click', this.showMenu);
      scrollService.addScrollListener('scroll-div-book-read', this.scrollFunction);
      this.$router.isBack = true;
    },
    beforeDestroy() {
      scrollService.removeScrollListener('scroll-div-book-read', this.scrollFunction);
    }
  }
</script>

<style scoped>
  #bottom-nav, #top-nav {
    transition: bottom linear 0.1s, top linear 0.1s;
  }
  * {
    z-index: 9;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layer2/book/read.vue